import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  // withCredentials intentionally off: we use Bearer tokens (no cookies)
});

let _token = null;

export function setAuthToken(token) {
  _token = token;
  if (token) {
    localStorage.setItem("neuracom_token", token);
  } else {
    localStorage.removeItem("neuracom_token");
  }
}

export function getStoredToken() {
  if (_token) return _token;
  _token = localStorage.getItem("neuracom_token");
  return _token;
}

api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function extractErrorCode(err) {
  return (
    err?.response?.data?.detail?.error_code ||
    err?.response?.data?.error_code ||
    "UNKNOWN_ERROR"
  );
}
